import styled from 'styled-components'

export const PageWrapperElement = styled.div`
  height: var(--page-height);
  flex: 0 0 var(--page-height);
  min-height: 0;
  overflow: hidden;
`
